import { FormConfig } from '@/Modules/Forms/models'
import { ProcessesFormsPages } from '@/Modules/ProcessesForms/router'
import { AxiosError } from 'axios'
import * as _ from 'lodash-es'
import moment from 'moment'
import { Component, MapGetter, Vue, Watch } from 'types-vue'
import { FilesApi } from '../../connections/api/Files'
import { Store } from '@/Core/Models/Stores'
import { SystemSubject } from '@/Modules/Auth/models'
const CORE_URL = process.env.VUE_APP_CORE_URL

@Component
export default class P04 extends Vue {
  protected showForm: boolean = true
  protected formData: any = {}
  protected loading: boolean = false
  protected errors: string[] = []
  protected keyname: string = null
  protected modEffectDate: string = null
  protected defaultDispatchingCompany: string = null
  protected disabledDispatchingCompany: boolean = false

  @MapGetter(Store.UserGroups) protected systemSubject: SystemSubject

  protected get formOptions(): FormConfig {
    return {
      label: 'Inicio',
      submitButton: 'Crear proceso',
      items: [
        {
          type: 'select',
          name: 'dispatchingcompany',
          label: 'Empresa Emisora del Paso',
          options: `${CORE_URL}/system-subjects?categories=COM,CLI`,
          placeholder: 'Selecciona empresa',
          valueQuery: 'code',
          default: this.defaultDispatchingCompany,
          disabled: this.disabledDispatchingCompany
        },
        {
          type: 'select',
          name: 'destinycompany',
          label: 'Empresa Receptora del Paso',
          options: `${CORE_URL}/system-subjects?categories=GRE,DIS`,
          placeholder: 'Selecciona empresa',
          valueQuery: 'code'
        },
        {
          type: 'text',
          name: 'comreferencenum',
          label: 'Referencia',
          placeholder: 'Introduce el numero de referencia'
        },
        {
          type: 'select',
          name: 'titulartype',
          label: 'Tipo de titular',
          placeholder: 'Selecciona el tipo de titular',
          options: `${CORE_URL}/client-person-types`,
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'nationality',
          label: 'Nacionalidad',
          placeholder: 'Selecciona la nacionalidad',
          options: `${CORE_URL}/location-nationalities`,
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'documenttype',
          label: 'Tipo Documento de Identificación',
          placeholder: 'Selecciona el tipo de documento',
          options: `${CORE_URL}/client-document-types`,
          valueQuery: 'code'
        },
        {
          type: 'text',
          name: 'documentnum',
          label: 'Nº Documento',
          placeholder: 'Escribe el número de documento'
        },
        {
          type: 'text',
          name: 'cups',
          label: 'CUPS Solicitud',
          placeholder: 'Introduce el CUPS',
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'cancelreason',
          label: 'Motivo de Baja',
          options: `${CORE_URL}/contract-unsubscribe-reasons`,
          placeholder: 'Introduce el motivo de baja',
          valueQuery: 'code'
        },
        {
          type: 'select',
          name: 'modeffectdate',
          label: 'Modelo Fecha Efecto',
          options: `${CORE_URL}/contract-effect-date-models`,
          placeholder: 'Introduce modelo fecha efecto',
          valueQuery: 'code'
        },
        {
          type: 'date',
          name: 'reqcanceldate',
          label: 'Fecha de Baja Solicitada',
          placeholder: 'Introduce la fecha de baja',
          valueQuery: 'code',
          disabled:
            this.modEffectDate === '01' ||
            this.modEffectDate === '02' ||
            this.modEffectDate === '05'
        },
        {
          type: 'time',
          name: 'cancelhour',
          label: 'Hora de Cierre',
          placeholder: 'Introduce la hora de cierre',
          valueQuery: 'code',
          disabled:
            this.modEffectDate === '01' ||
            this.modEffectDate === '02' ||
            this.modEffectDate === '05'
        },
        {
          type: 'text',
          name: 'contactphonenumber',
          label: 'Teléfono',
          placeholder: 'Introduce el teléfono de contacto',
          valueQuery: 'code'
        },
        {
          type: 'textarea',
          name: 'extrainfo',
          label: 'Observaciones de la solicitud',
          placeholder: 'Introduce las observaciones de la solicitud'
        }
      ],
      rules: {
        dispatchingcompany: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        destinycompany: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        comreferencenum: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        reqdate: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        reqhour: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        nationality: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        documenttype: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        documentnum: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        cups: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        cancelreason: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        modeffectdate: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }],
        contactphonenumber: [{ required: true, trigger: 'blur', message: 'Es obligatorio' }]
      }
    }
  }

  private updateFormData(newData: any) {
    this.formData = { ...this.formData, ...newData }
  }

  private getProcessData() {
    const currentDate = moment().format('YYYY-MM-DD')
    const currentHour = moment().format('hh:mm:ss')

    return {
      heading: {
        dispatchingcode: 'GML',
        dispatchingcompany: this.formData?.dispatchingcompany,
        destinycompany: this.formData?.destinycompany,
        communicationsdate: currentDate,
        communicationshour: currentHour,
        processcode: '04',
        messagetype: 'A1'
      },
      a104: [
        {
          comreferencenum: this.formData?.comreferencenum,
          reqdate: currentDate,
          reqhour: currentHour,
          titulartype: this.formData?.titulartype,
          nationality: this.formData?.nationality,
          documenttype: this.formData?.documenttype,
          documentnum: this.formData?.documentnum,
          cups: this.formData?.cups,
          cancelreason: this.formData?.cancelreason,
          modeffectdate: this.formData?.modeffectdate,
          reqcanceldate: this.formData?.reqcanceldate
            ? moment(this.formData?.reqcanceldate).format('YYYY-MM-DD')
            : '',
          cancelhour: this.formData?.cancelhour
            ? moment(this.formData?.cancelhour).format('hh:mm:ss')
            : '',
          contactphonenumber: this.formData?.contactphonenumber,
          extrainfo: this.formData?.extrainfo // new
        }
      ]
    }
  }

  /**
   * FORMS CALLBACKS
   */

  protected async onSubmit(newData: any) {
    this.updateFormData(newData)
    const process = this.getProcessData()
    // console.log('los datos', newData)
    // console.log('el proceso', process)

    try {
      this.loading = true
      this.showForm = false

      const response = await FilesApi.generateProcess(process)

      this.errors = response.data.body.error
      this.keyname = response.data.keyname
    } catch (err) {
      const error = err as AxiosError
      const messagaError = error?.response?.data?.message || 'Error al cargar las facturas.'

      this.$notify.error({ title: `Error ${error?.response?.status}`, message: messagaError })
    } finally {
      this.loading = false
    }
  }

  protected onChange(form) {
    this.modEffectDate = form.modeffectdate
  }

  protected handleReturn() {
    this.showForm = true
  }

  @Watch('systemSubject', { deep: true, immediate: true })
  protected onChangeSystemSubject() {
    const specialSubjects = ['0000', '0234']

    if (this.systemSubject.code && !specialSubjects.includes(this.systemSubject.code)) {
      this.defaultDispatchingCompany = this.systemSubject.code
      this.disabledDispatchingCompany = true
    }
  }
}
